import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Providers from './providers/Providers';
import Layout from './shared/bar/layout';

import Home from './pages/home';
import Bookings from './pages/bookings';
import Book from './pages/book';
import Account from './pages/account';
import Settings from './pages/settings';
import Login from './pages/login';
import Register from './pages/register';
import ForgotPassword from './pages/forgotPassword';
import RegisterPassword from './pages/registerPassword';
import Information from './pages/information';
import Admin from './pages/admin';
import NoPage from './pages/noPage';
import ProtectedRoute from './shared/routeWrapper';
import Company from './pages/company';
import ACLProtectedRoute from './shared/aclRouteWrapper';
import Display from './pages/display';
import { ACL } from './acls.js';

import './css/index.css';
import './css/toast.css';
import DisplayOnlyRoute from './shared/displayRouteWrapper';
export default function App() {
  return (
    <Providers>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout emptyBar={true} />}>
            <Route index element={<Login />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="password" element={<RegisterPassword />} />
            <Route path="register" element={<Register />} />
          </Route>

          <Route element={<Layout />}>
            <Route element={<ProtectedRoute />}>
              <Route path="home" element={<Home />} />
              <Route path="book" element={<Book />} />
              <Route path="bookings" element={<Bookings />} />
              <Route path="account" element={<Account />} />
              <Route path="company" element={<Company />} />
              <Route path="settings" element={<Settings />} />
              <Route path="information" element={<Information />} />
              <Route path="*" element={<NoPage />} />
            </Route>

            <Route element={<ACLProtectedRoute aclName= {ACL.ADMIN_PANEL} />}>
              <Route path="admin" element={<Admin />} />
            </Route>

            <Route element={<ACLProtectedRoute aclName= {ACL.COMPANY} />}>
              <Route path="/company/:id" element={<Company />} />
            </Route>

          </Route>

          <Route element={<DisplayOnlyRoute />}>
            <Route >
              <Route path="display" element={<Display />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </Providers>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);